export function filterNullParams<T extends Record<string, any>>(obj: T): Partial<T> {
	const cleanObj = {} as Partial<T>
	Object.entries(obj).forEach(([key, value]) => {
		const k = key as keyof T
		if (value && typeof value === 'object' && !Array.isArray(value)) {
			const nestedObj = filterNullParams(value as Record<string, any>)
			if (Object.keys(nestedObj).length > 0) {
				cleanObj[k] = nestedObj as T[keyof T]
			}
		} else if (
			value !== null &&
			value !== 'null' &&
			value !== undefined &&
			!(Array.isArray(value) && value.length === 0)
		) {
			cleanObj[k] = value as T[keyof T]
		}
	})
	return cleanObj
}
